import { defineCustomElement, BaseController } from '@mrhenry/wp--custom-elements-helpers';

defineCustomElement( 'mr-toggle', {
	attributes: [
		{
			attribute: 'target',
			type: 'string',
		},
		{
			attribute: 'toggle-class',
			type: 'string',
		},
	],
	controller: class extends BaseController {
		init() {
			this.elements = {};

			this.elements.button = this.el.querySelector( '.js-toggle-button' );

			if ( this.target ) {
				this.elements.target = document.querySelector( this.target );
			}
		}

		bind() {
			this.on( 'click', () => {
				if ( this.elements.button ) {
					this.elements.button.classList.toggle( 'is-toggled' );
				}

				if ( this.elements.target ) {
					this.elements.target.classList.toggle( this.toggleClass );
				}
			} );
		}
	},
} );
